/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Iframe_Remote_Display_Settings_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to update display settings: {error}" |
*
* @param {Iframe_Remote_Display_Settings_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_display_settings_failed_toast = /** @type {((inputs: Iframe_Remote_Display_Settings_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Display_Settings_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de mise a jour des parametres d'affichage : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Aktualisierung der Anzeigeeinstellungen fehlgeschlagen: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile aggiornare le impostazioni di visualizzazione: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось обновить настройки дисплея: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo actualizar la configuración de pantalla: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`显示设置更新失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`表示設定の更新に失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`डिस्प्ले सेटिंग्स को अपडेट करने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao atualizar as configurações de exibição: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to update display settings: ${i?.error}`)
});